import React, { useState, useEffect } from 'react';

import './cmspages.scss';
import loader from '../../assets/images/Loader.png'
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
import DataService from '../../lib/DataService';
const LegalNotice = (props) => {

	const { getRequest } = DataService()

    const [loading, setLoading] = useState(false);
    const { t } = useTranslation()
    useEffect(() => {
        fetchlegal()
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, [])

    const [legal, setLegal] = useState("")

    const fetchlegal = async () => {
        setLoading(true)
        const legaldata = await getRequest(`home/cms?title=Legal Notice`)
        if (legaldata.status == true) {
            setLoading(false)
            setLegal(legaldata.data)
        }
        else {
            setLoading(false)
            setLegal("")
        }
    }

    useEffect(() => {

        document.title = 'Legal Notices | Wor NFT'
    }, [])



    return (
        <>
            <div className={`text-center ${loading ? 'spinner' : 'd-none'}`}>
                <img src={loader} alt='' className='spinAnimate' />
            </div>
            <div className="container">
                <div className='row justify-content-center'>
                    <div className="col-lg-9">
                        <div className='d-flex justify-content-between mb-4 flex-wrap align-items-center'>
                            <div className='cmsTit'>{t("Legal Notices")}</div>
                            <div className='cmsdateTxt'>{t("Last modification")}: {new Date(
                                legal ? legal && legal.updatedAt : ""
                            ).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
                        </div>
                        {ReactHtmlParser(legal ? legal && legal.pagecontent : "")}
                    </div>
                </div>
            </div>
        </>
    )
}

export default LegalNotice;